import React from "react";

const Bash_Script = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Script</h2>
      <p>Create executable scripts with a shebang and make them executable.</p><pre><code>#!/usr/bin/env bash

echo "Hello from script"
</code></pre><p>Save as <code>script.sh</code> then <code>chmod +x script.sh</code> and run <code>./script.sh</code>.</p>
    </div>
  );
};

export default Bash_Script;
